import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDBox from "components/MDBox";
import UiCard from "components/base/UiCard";
import UiTypography from "components/base/UiTypography";
import { ProposalProduct } from "generated/graphql";
import ProposalProductFiles from "modules/proposals/ProposalProductFiles";
import AddFilesToProduct from "modules/proposals/AddFilesToProduct";
import AddProjectFileToProposal from "modules/proposals/AddProjectFileToProposal";

type FilesAndNotesProps = {
  product: ProposalProduct;
};

const projectFileButtonSx = {
  "& .MuiButton-root": {
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "none",
    padding: "6px 16px",
    borderRadius: "8px",
    minHeight: "32px",
    boxShadow: "none",
  },
  "& .MuiTypography-root": { fontSize: "12px", ml: "4px !important" },
  "& .MuiSvgIcon-root": { fontSize: "16px !important" },
} as const;

const uppySx = {
  width: "100%",
  position: "relative",
  "& .uppy-DragDrop-inner": { padding: "16px 0" },
  "& .uppy-DragDrop-label": { fontSize: "1em" },
} as const;

export default function FilesAndNotes({ product }: FilesAndNotesProps) {
  return (
    <UiCard variant="inner">
      <Accordion
        defaultExpanded={false}
        disableGutters
        elevation={0}
        sx={{
          backgroundColor: "transparent",
          "&::before": { display: "none" },
          "& .MuiAccordionSummary-root": { minHeight: 0, p: 0 },
          "& .MuiAccordionSummary-content": { m: 0 },
          "& .MuiAccordionDetails-root": { p: 0, pt: "8px" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            flexDirection: "row-reverse",
            gap: "8px",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.02)", borderRadius: "6px" },
          }}
        >
          <UiTypography uiVariant="heading-sm">Product Files</UiTypography>
        </AccordionSummary>
        <AccordionDetails>
          <ProposalProductFiles />

          <MDBox sx={uppySx}>
            <AddFilesToProduct />
          </MDBox>

          <MDBox sx={projectFileButtonSx}>
            <AddProjectFileToProposal id={product.id} />
          </MDBox>
        </AccordionDetails>
      </Accordion>
    </UiCard>
  );
}
